/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AiSuggestionAccepted
 */
export interface AiSuggestionAccepted {
    /**
     * Name of the prompt whose suggestion was accepted (e.g. "Generate Prescription")
     * @type {string}
     * @memberof AiSuggestionAccepted
     */
    prompt: string;
    /**
     * 
     * @type {string}
     * @memberof AiSuggestionAccepted
     */
    patient_id?: string;
    /**
     * Optional extra context (e.g. medication name, appointment id)
     * @type {{ [key: string]: any; }}
     * @memberof AiSuggestionAccepted
     */
    metadata?: { [key: string]: any; };
}

/**
 * Check if a given object implements the AiSuggestionAccepted interface.
 */
export function instanceOfAiSuggestionAccepted(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "prompt" in value;

    return isInstance;
}

export function AiSuggestionAcceptedFromJSON(json: any): AiSuggestionAccepted {
    return AiSuggestionAcceptedFromJSONTyped(json, false);
}

export function AiSuggestionAcceptedFromJSONTyped(json: any, ignoreDiscriminator: boolean): AiSuggestionAccepted {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prompt': json['prompt'],
        'patient_id': !exists(json, 'patient_id') ? undefined : json['patient_id'],
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
    };
}

export function AiSuggestionAcceptedToJSON(value?: AiSuggestionAccepted | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'prompt': value.prompt,
        'patient_id': value.patient_id,
        'metadata': value.metadata,
    };
}

